module.exports = __webpack_public_path__ + "static/media/cursor.1f24dce1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cursor.png
// module id = 756
// module chunks = 0